export default __webpack_public_path__ + "static/media/profile_prof.0a8d7fb6.png";